var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sea-parent"},[_c('div',{staticClass:"sea-bottom",style:({top:_vm.seaTop,height:_vm.seaHeight})}),_c('div',{staticClass:"sea",class:_vm.type,style:({top:_vm.top+'px',backgroundPositionX:_vm.x+'px'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }